// src/assets/Images.js
import Canva from "../assets/imageSkills/canva-logo.png";
import CSS from "../assets/imageSkills/css3-logo.png";
import Figma from "../assets/imageSkills/figma-logo.png";
import Git from "../assets/imageSkills/git-logo.png";
import GitHub from "../assets/imageSkills/github-logo.png";
import HTML5 from "../assets/imageSkills/html5-logo.png";
import JavaScript from "../assets/imageSkills/javascript-logo.png";
import TypeScript from "../assets/imageSkills/typescript-logo.png";
import MySql from "../assets/imageSkills/mysql-logo.png";
import Postman from "../assets/imageSkills/postman-logo.png";
import React from "../assets/imageSkills/react-logo.png";
import VueJs from "../assets/imageSkills/vueJs-logo.webp";
import Mui from "../assets/imageSkills/mui-logo.png";
import Antdesign from "../assets/imageSkills/antdesign-logo.png";

const Images = {
  canva: Canva,
  css3: CSS,
  figma: Figma,
  git: Git,
  github: GitHub,
  html5: HTML5,
  javascript: JavaScript,
  typescript: TypeScript,
  mysql: MySql,
  postman: Postman,
  react: React,
  vuejs: VueJs,
  mui: Mui,
  antdesign: Antdesign,
};

export default Images;
